type HeatmapDetailsProps = {
  value: string;
  date: string;
  facility: string;
};

const HeatmapDetails = (props: HeatmapDetailsProps) => {
  return (
    <div className="w-[144px] flex flex-col space-y-1 bg-[#ee83c5] h-24 text-black">
      <p>{props.value}</p>
      <p>{props.date}</p>

      <div>
        <p>Facility</p>
        <p>{props.facility}</p>
      </div>
    </div>
  );
};

export default HeatmapDetails;
